document.addEventListener('DOMContentLoaded', function () {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function ({ data }) {
    const variant = data?.variant;
    if (!variant) return;

    console.log('🧩 Variant changed:', variant.title, '→', variant.id);

    const flavorChooser = document.querySelector('.bundle-chooser');
    const summary = flavorChooser?.querySelector('.bundle-chooser__summary span');
    const grid = flavorChooser?.querySelector('.bundle-chooser__grid');
    if (!flavorChooser || !grid || !summary) return;

    let count = 0;
    if (variant.title.includes('32')) count = 4;
    else if (variant.title.includes('64')) count = 8;
    else if (variant.title.includes('1 Gallon')) count = 16;

    summary.textContent = `Choose your ${count} flavors`;

     // Show/hide fields and toggle "required"
    grid.querySelectorAll('.bundle-chooser__field select').forEach((select, i) => {
      if (i < count) {
        select.closest('.bundle-chooser__field').style.display = 'block';
        select.setAttribute('required', '');
      } else {
        select.closest('.bundle-chooser__field').style.display = 'none';
        select.removeAttribute('required');
      }
    });

    const counter = flavorChooser.querySelector('.bundle-chooser__count');
    if (counter) counter.textContent = `(0/${count} selected)`;
  });
});
